import { getMiddlewareUrl } from './getMiddlewareUrl'

/**
 * Post offer click to middleware
 * @param {string} offer - slug of offer
 * @returns {Promise<void>}
 */
export async function saveOfferClick(offer) {
  const BASE_URL = getMiddlewareUrl()
  try {
    const success = await fetch(`${BASE_URL}/api/clicks/incr`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ cache_key: `offer_${offer}_clicks` }),
    })

    if (!success) {
      console.error('unable to save click')
    }
  } catch (error) {
    console.error(error, 'unable to save click')
  }
}
